// extracted by mini-css-extract-plugin
export default {"ModalConfirm":"index_ModalConfirm__GR2u+"};